import type { Config } from "./default"

export default {
  mode: "production",
  frontendUrl: "https://incmix.com",
  backendUrl: "https://incmix.com/api/v1",
  tusUrl: "https://incmix.com/upload",
} satisfies Config
